import { CircularProgress, IconButton, Tooltip } from '@material-ui/core'
import PublishIcon from '@material-ui/icons/Publish'
import { useState } from 'react'
import useTranslator from 'utils/hooks/Translator'
import useAgents from 'utils/hooks/useAgents'

export function PublishButton() {
  const { getTranslation } = useTranslator()
  const { isAgentFreeToUse, publishAgent } = useAgents()
  const [loadPublish, setLoadPublish] = useState(false)

  const handlePublish = async () => {
    const botInUse = await isAgentFreeToUse(true)

    if (botInUse) {
      if (loadPublish) return
      setLoadPublish(true)
      await publishAgent()
      setLoadPublish(false)
    }
  }

  return (
    <Tooltip title={getTranslation('menu.publish')} placement="right">
      <IconButton
        onClick={handlePublish}
        style={{
          width: 44,
          height: 44,
          margin: '32px auto 6px 6px',
          background: '#59A96A',
          color: '#fff',
        }}
      >
        {loadPublish ? (
          <CircularProgress color="inherit" size={22} />
        ) : (
          <PublishIcon fontSize="medium" />
        )}
      </IconButton>
    </Tooltip>
  )
}
